import { Account } from "../../_app/types";
import { Stack } from "@mui/material";
import AccountCard from "./AccountCard";

interface Props {
  accounts: Account[];
  activeAccount: string;
  onChangeAccount: (value: Account) => void;
}

const AccountsList = ({ accounts, activeAccount, onChangeAccount }: Props) => {
  return (
    <Stack sx={{ width: "100%" }} direction={"column"} justifyContent={"center"} spacing={1}>
      {accounts.map((account: Account, index: number) => (
        <AccountCard
          key={index}
          account={account}
          activeAccount={activeAccount}
          onChangeAccount={onChangeAccount}
        />
      ))}
    </Stack>
  );
};

export default AccountsList;
